import React, { useState } from "react";

import styles from "./BulkUploadTabs.module.css";
import ZIPUpload from "./tabs/ZIPUpload";
import CloudStorage from "./tabs/CloudStorage";
import ProcessingQueue from "./tabs/ProcessingQueue";
import UploadHistory from "./tabs/UploadHistory";
import BulkUpload from "../bulkUpload.js/BulkUpload";
import FeedImport from "./tabs/XMLMRSSFeed";
import MediaLibraryModal from "../../component/mediaLibrary/MediaLibraryModal";
import Button from "../../component/button/Button";
import Bunny from "./tabs/Bunny";
import useUrlTab from "../../hooks/useUrlTab";

const tabs = [
  "CSV/Excel Upload",
  "ZIP Bulk Upload",
  "Cloud Storage",
  "Bunny Integration",
  "XML/MRSS Feed",
  "Processing Queue",
  "Upload History",
];
const BulkUploadNew = () => {
  const [activeTab, setActiveTab] = useUrlTab(tabs, "CSV/Excel Upload");
  const [isOpen, setIsOpen] = useState(false);

  const renderTab = () => {
    switch (activeTab) {
      case "CSV/Excel Upload":
        return <BulkUpload polling={true} />;
      case "ZIP Bulk Upload":
        return <ZIPUpload />;
      case "Cloud Storage":
        return <CloudStorage />;
        case "Bunny Integration":
        return <Bunny />;
      case "XML/MRSS Feed":
        return <FeedImport />;
      case "Processing Queue":
        return <ProcessingQueue />;
      case "Upload History":
        return <UploadHistory />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.Tabswrapper}>
      <div className={styles.MediaLibraryBtn}>
        <Button onClick={() => setIsOpen(true)}>Media Library</Button>
      </div>
      {isOpen ? (
        <MediaLibraryModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          mode={"modal"}
        />
      ) : (
        ""
      )}
      <div className={styles.tabHeader}>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={tab === activeTab ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className={styles.tabContent}>{renderTab()}</div>
    </div>
  );
};

export default BulkUploadNew;
